module.exports = __webpack_public_path__ + "img/expired-policy.9206cf1c.png";